import React, { Component } from 'react';
import ACContainer from './container';
import { connect } from 'react-redux';
import R from 'ramda';

import { getInfoFromToken, updateProps, clearStore } from './__storeFiles__/actions';

class AssetsConsolidationRouter extends Component {
  componentDidMount() {
    const { params, location, getInfoFromToken, updateProps } = this.props;
    updateProps({ hashToken: params.hashToken, associateEmail: R.pathOr('', ['query', 'associateEmail'], location) })
    getInfoFromToken(params.hashToken);
  }
  componentWillUnmount() {
    this.props.clearStore();
  }
  render () {
    const { params } = this.props;
    const props = {
      hashToken: params.hashToken,
    };
    return (
      <div>
        <ACContainer
          {...props}
        />
      </div>
    );
  }
}

export default connect(null, {
  getInfoFromToken,
  updateProps,
  clearStore,
})(AssetsConsolidationRouter);



// WEBPACK FOOTER //
// ./src/app/components/assets-consolidation/router.jsx